<template>
  <div>
    <div class="py-3"></div>

    <!-- 상단: 스토어 통합 탭 -->
    <v-card class="mx-auto" max-width="95%" elevation="2">
      <v-toolbar color="light-blue darken-3" dark flat>
        <v-toolbar-title>
          <v-icon left>mdi-storefront-outline</v-icon>
          스토어
        </v-toolbar-title>
      </v-toolbar>
      <v-tabs v-model="tab" background-color="grey lighten-4" show-arrows>
        <v-tab>
          <v-icon left small>mdi-chart-box-outline</v-icon>대시보드
        </v-tab>
        <v-tab>
          <v-icon left small>mdi-ticket-confirmation-outline</v-icon>상품
        </v-tab>
        <v-tab>
          <v-icon left small>mdi-shape-outline</v-icon>카테고리
        </v-tab>
        <v-tab>
          <v-icon left small>mdi-view-grid-outline</v-icon>노출설정
        </v-tab>
        <v-tab>
          <v-icon left small>mdi-receipt-text-outline</v-icon>주문/매출
        </v-tab>
      </v-tabs>
    </v-card>

    <!--
      각 탭은 기존 쿠폰 화면 컴포넌트를 그대로 재사용한다.
      v-tab-item 은 지연 렌더(lazy)라 처음 선택한 탭만 mounted → 진입 시 4개가 한꺼번에 조회되지 않는다.
      한 번 연 탭은 상태가 유지되며, 각 화면에 [조회]/[새로고침] 이 있어 수동 갱신할 수 있다.
    -->
    <v-tabs-items v-model="tab" class="store-tabs-items">
      <v-tab-item>
        <Coupon_Dashboard />
      </v-tab-item>
      <v-tab-item>
        <Coupon_Products />
      </v-tab-item>
      <v-tab-item>
        <Coupon_Categories />
      </v-tab-item>
      <v-tab-item>
        <Coupon_Placements />
      </v-tab-item>
      <v-tab-item>
        <Coupon_Orders />
      </v-tab-item>
    </v-tabs-items>

    <div class="py-6"></div>
  </div>
</template>

<script>
import Coupon_Dashboard from '../coupon/Coupon_Dashboard.vue';
import Coupon_Products from '../coupon/Coupon_Products.vue';
import Coupon_Categories from '../coupon/Coupon_Categories.vue';
import Coupon_Placements from '../coupon/Coupon_Placements.vue';
import Coupon_Orders from '../coupon/Coupon_Orders.vue';

// 탭 인덱스 ↔ 쿼리스트링 키 (새로고침/북마크 시 탭 유지)
const TAB_KEYS = ['dashboard', 'products', 'categories', 'placements', 'orders'];

export default {
  name: 'Store_Main',
  components: {
    Coupon_Dashboard,
    Coupon_Products,
    Coupon_Categories,
    Coupon_Placements,
    Coupon_Orders,
  },
  data: () => ({
    tab: 0,
  }),
  created() {
    const idx = TAB_KEYS.indexOf(this.$route.query.tab);
    if (idx >= 0) this.tab = idx;
  },
  watch: {
    tab(v) {
      const key = TAB_KEYS[v] || TAB_KEYS[0];
      if (this.$route.query.tab === key) return;
      // 같은 경로에서 쿼리만 교체 (중복 내비게이션 오류는 무시)
      this.$router.replace({ query: { ...this.$route.query, tab: key } }).catch(() => {});
    },
  },
};
</script>

<style scoped>
/*
  v-tabs-items(VWindow)는 기본 배경이 흰색이라, 자식 화면 카드(max-width:95%)와
  페이지 배경(#F5F5F5) 사이에 전체폭 흰 띠가 생겨 이질감이 있다.
  투명 처리해서 다른 화면들과 동일한 회색 배경이 비치게 한다.
*/
.store-tabs-items,
.store-tabs-items >>> .v-window__container,
.store-tabs-items >>> .v-window-item {
  background-color: transparent !important;
}
</style>
